import type { Timeline } from 'types/cms/blocks/Timeline';

const FIRST_YEAR = 2007;

const getAllYears = () =>
  Array.from(
    { length: new Date().getFullYear() - FIRST_YEAR + 1 },
    (_, i) => FIRST_YEAR + i,
  );

export const calcEmptyFollowingYears = (
  currentYear: number,
  yearsData: Timeline['years'],
): number => {
  const allYears = getAllYears();
  // We only want the years following the current year so lets trim the array down
  const currentYearIndex = allYears.indexOf(currentYear);
  const followingYears = allYears.slice(currentYearIndex + 1);

  let yearsWithNoEvents: number[] = [];

  for (const y of followingYears) {
    const currentYearData = yearsData.find((data) => data.year === y);
    // If the current year data has any events, we want to stop checking anymore
    if (currentYearData?.events && currentYearData.events.length > 0) {
      break;
    }
    // Otherwise add to the array of years with no events
    yearsWithNoEvents = [...yearsWithNoEvents, y];
  }

  return yearsWithNoEvents.length;
};

export const calcTodayPosition = (currentYear: number): string | null => {
  const today = new Date();

  if (today.getFullYear() === currentYear) {
    const percentagePosition = ((today.getMonth() + 1) / 12) * 100;

    return `${percentagePosition.toFixed(2)}%`;
  }

  return null;
};
